import React from "react";
import bgHeader from "../../assets/images/Newsletter/images/bg-header.png";
import banner from "../../assets/images/Newsletter/August-2025/banner.png";
import sushil from "../../assets/images/Newsletter/images/shushil-Gujrathi.png";
import IndianConsumerSolutionsCompany from "../../assets/images/Newsletter/August-2025/3.png";
import AviationCompany from "../../assets/images/Newsletter/August-2025/2.png";
import RealEstateCompany from "../../assets/images/Newsletter/August-2025/5.jpg";
import RealEstateCompany2 from "../../assets/images/Newsletter/August-2025/4.jpg";
import GolfBrand from "../../assets/images/Newsletter/August-2025/golf.jpg";
import DubaiEvent from "../../assets/images/Newsletter/August-2025/8.jpg";
import abhishek from "../../assets/images/Newsletter/August-2025/abhishek.jpeg";
import BusinessQuote2 from "../../assets/images/Newsletter/August-2025/cris.jpg";
import rishabh from "../../assets/images/Newsletter/August-2025/Rishabh.png";
import JuhiShah from "../../assets/images/Newsletter/August-2025/JuhiShah.jpg";
import joinees from "../../assets/images/Newsletter/August-2025/welcome-collage.jpg";
import daji from "../../assets/images/Newsletter/August-2025/daaji.png";
import city from "../../assets/images/Newsletter/images/city.png";
import fb1 from "../../assets/images/Newsletter/images/fb1.png";
import tw1 from "../../assets/images/Newsletter/images/tw1.png";
import ln1 from "../../assets/images/Newsletter/images/ln1.png";
import ig1 from "../../assets/images/Newsletter/images/ig1.png";
import yt1 from "../../assets/images/Newsletter/images/yt1.png";
import BusinessQuoteOne from "../../assets/images/Newsletter/August-2025/Estee-Lauder.jpg";
import caseStudy from "../../assets/images/Newsletter/August-2025/casestudytwo.png";
import RetailInMotion from "../../assets/images/Newsletter/August-2025/Retail-in-Motion.jpg";
import PoweringPersonalizedRetailWithSalesforce from "../../assets/images/Newsletter/August-2025/Powering-Personalized-Retail-with-Salesforce.jpeg";
import annualPicnic from "../../assets/images/Newsletter/August-2025/picnic.png";
import Celebration from "../../assets/images/Newsletter/August-2025/13.jpeg";
import NavaratriCelebration from "../../assets/images/Newsletter/August-2025/navratri-collage.jpg";
import rupesh from "../../assets/images/Newsletter/August-2025/Rupesh.jpg";
import MarTechTransformationDeal from "../../assets/images/Newsletter/August-2025/6.jpg";
import award from "../../assets/images/Newsletter/August-2025/award2.png";

const September = () => {
  return (
    <>
      <>
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        {/*[if !mso]><!*/}
        <meta httpEquiv="X-UA-Compatible" content="IE=edge" />
        {/*<![endif]*/}
        <meta name="viewport" content="width=device-width,initial-scale=1" />
        <title>COMSENSE - NEWSLETTER June-2025</title>
        <link
          rel="shortcut icon"
          href="https://www.comsenseconsulting.com/images/ico/favicon.ico"
        />
        <style
          dangerouslySetInnerHTML={{
            __html:
              "\n    @import url(https://fonts.googleapis.com/css2?family=Cookie&display=swap);\n    @import url(https://fonts.googleapis.com/css2?family=Open+Sans:wght@300;400;500&display=swap);\n\n    @import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');\n\n    @font-face {\n      font-family: 'Century Gothic', sans-serif;\n      src: url(fonts/CenturyGothic.ttf);\n    }\n\n    html {\n      font-family: century-gothic, sans-serif;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .ReadMsgBody {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass {\n      width: 100%;\n      background-color: #fff\n    }\n\n    .ExternalClass,\n    .ExternalClass div,\n    .ExternalClass font,\n    .ExternalClass p,\n    .ExternalClass span,\n    .ExternalClass td {\n      line-height: 100%\n    }\n\n    html {\n      width: 100%\n    }\n\n    body {\n      -webkit-text-size-adjust: none;\n      -ms-text-size-adjust: none;\n      margin: 0;\n      padding: 0;\n      font-family: 'Open Sans', Arial, Sans-serif !important;\n      font-family: \"Montserrat\", sans-serif !important;\n    }\n\n    table {\n      border-spacing: 0;\n      table-layout: fixed;\n      margin: 0 auto\n    }\n\n    table table table {\n      table-layout: auto\n    }\n\n    img {\n      display: block !important;\n      overflow: hidden !important\n    }\n\n    .yshortcuts a {\n      border-bottom: none !important\n    }\n\n    img:hover {\n      opacity: .9 !important\n    }\n\n    a {\n      color: red;\n      text-decoration: none\n    }\n\n    .textbutton a {\n      font-family: 'open sans', arial, sans-serif !important;\n      font-family: \"Montserrat\", sans-serif;\n    }\n\n    .btn-link a {\n      color: #fff !important\n    }\n\n    ul {\n      padding-inline-start: 20px\n    }\n\n    ol {\n      padding-inline-start: 20px\n    }\n\n    .mobile-responsive {\n      display: none\n    }\n\n    .image-reponsive {\n      float: left;\n      margin-left: 0;\n      margin-right: 25px;\n      margin-top: 10px\n    }\n\n    @media only screen and (max-width:640px) {\n      body {\n        margin: 0;\n        width: auto !important;\n        font-family: 'Open Sans', Arial, Sans-serif !important\n      }\n\n      .table-inner {\n        width: 90% !important;\n        max-width: 90% !important\n      }\n\n      .table-full {\n        width: 100% !important;\n        max-width: 100% !important;\n        text-align: center !important\n      }\n\n      #sagar img {\n        width: 50%\n      }\n\n      .mobile-responsive {\n        display: block\n      }\n\n      .desktop-view {\n        display: none\n      }\n\n      .image-reponsive {\n        float: unset;\n        margin: 0 auto 10px\n      }\n\n      @media only screen and (max-width:479px) {\n        body {\n          width: auto !important;\n          font-family: 'Open Sans', Arial, Sans-serif !important\n        }\n\n        .table-inner {\n          width: 90% !important;\n          text-align: center !important\n        }\n\n        .table-full {\n          width: 100% !important;\n          max-width: 100% !important;\n          text-align: center !important\n        }\n\n        u+.body .full {\n          width: 100% !important;\n          width: 100vw !important\n        }\n\n        #sagar img {\n          width: 50%\n        }\n      }\n    }\n  ",
          }}
        />
        <table
          className="full newsletter-emailer"
          width="100%"
          alignitems="center"
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td
                bgcolor="#333742"
                background={bgHeader}
                style={{
                  borderTop: "4px solid red",
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
                align="center"
              >
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td
                        height={40}
                        valign="top"
                        style={{
                          fontFamily: "Open sans,arial,sans-serif",
                          fontSize: 10,
                          color: "#fff",
                          lineHeight: "24px",
                          textAlign: "center",
                        }}
                      >
                        If this newsletter is not displayed correctly, please{" "}
                        <a href="/" style={{ color: "#fff" }}>
                          <u>click here</u>
                        </a>
                        .
                      </td>
                    </tr>
                    {/* <tr>
                      <td align="center">
                        <table
                          className="table-full"
                          align="centre"
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td align="center" style={{ lineHeight: 0 }}>
                                <img
                                  editable=""
                                  label="image"
                                  style={{
                                    display: "block",
                                    lineHeight: 0,
                                    fontSize: 0,
                                    border: 0,
                                  }}
                                  src={logo}
                                  width={160}
                                  alt="logo"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr> */}
                    {/* <tr>
                      <td height={25} />
                    </tr> */}
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td>
                        <img
                          editable=""
                          label="image"
                          style={{
                            display: "block",
                            lineHeight: 0,
                            fontSize: 0,
                            border: 0,
                          }}
                          src={banner}
                          width="100%"
                          alt="logo"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <repeater>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          id="sagar"
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={sushil}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: 0,
                                              width: 167,
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                </td>
                <td>
                  <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={90} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="center"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                  }}
                                                >
                                                  From the CEO’s Desk
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                              <tr>
                                                <td align="left">
                                                  <table
                                                    align="left"
                                                    width={30}
                                                    border={0}
                                                    cellSpacing={0}
                                                    cellPadding={0}
                                                  >
                                                    <tbody>
                                                      <tr>
                                                        <td
                                                          height={10}
                                                          style={{
                                                            borderBottom:
                                                              "3px solid red",
                                                          }}
                                                        />
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={20} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Dear Team,
                                              <br />
                                              <br />
                                              As we wrap up Q3, I am filled with
                                              pride and excitement at how far
                                              Comsense has come and for what
                                              lies ahead. The journey we
                                              embarked on earlier this year was
                                              not simply about growth, but{" "}
                                              <strong>
                                                about redefining who we are and
                                                what we stand for in a rapidly
                                                evolving world.
                                              </strong>
                                              <br />
                                              <br />
                                              Each quarter this year has added a
                                              unique chapter to our journey. Q1
                                              was about laying the foundation
                                              with clarity and ambition. Q2 was
                                              about momentum, turning intent
                                              into outcomes. And Q3 has been
                                              about acceleration—with AI,
                                              operational discipline, and a
                                              people-first culture shaping our
                                              story.
                                              <br />
                                              <br />
                                              <strong
                                                style={{ fontSize: "larger" }}
                                              >
                                                AI: From Vision to Impact
                                              </strong>
                                              <br />
                                              This quarter marked a decisive
                                              step in making AI central to
                                              everything we do. We took our{" "}
                                              <strong>
                                                AI accelerators
                                              </strong>{" "}
                                              from pilots to enterprise-scale
                                              adoption, delivering measurable
                                              outcomes for clients,{" "}
                                              <strong>
                                                improved execution speeds by up
                                                to 30%
                                              </strong>
                                              , and{" "}
                                              <strong>
                                                launched AI-readiness programs
                                              </strong>{" "}
                                              with 70% of our workforce actively
                                              upskilling. AI is no longer a
                                              future opportunity; it’s our force
                                              multiplier today.
                                              <br /> <br />
                                              <strong
                                                style={{ fontSize: "larger" }}
                                              >
                                                Strategic Progress
                                              </strong>
                                              <br />
                                              <strong>
                                                • Client Growth:{" "}
                                              </strong>{" "}
                                              CSAT rose 10% over two quarters,
                                              with expanded mandates from three
                                              strategic clients.
                                              <br />
                                              <strong>• Innovation: </strong>
                                              We transformed accelerators into
                                              production-grade impact, driving
                                              scalable solutions.
                                              <br />
                                              <strong>
                                                • People-First Culture:{" "}
                                              </strong>{" "}
                                              Engagement in learning reached new
                                              highs, proving that our people are
                                              the true drivers of progress.
                                              <br />
                                              <strong>
                                                • Operational Excellence:{" "}
                                              </strong>{" "}
                                              Governance and automation cut
                                              cycle times by 15%, reinforcing
                                              delivery precision.
                                              <br />
                                              <br />
                                              As we enter Q4, three priorities
                                              will guide us:{" "}
                                              <strong>
                                                embedding AI-first solutions,
                                                scaling meaningful client
                                                growth, and investing in
                                                future-ready talent.
                                              </strong>
                                              <br />
                                              <br />
                                              The story of Comsense is being
                                              written not by one leader or one
                                              team, but by the collective belief
                                              and commitment of all of us. Q3
                                              has been proof that when we
                                              combine ambition with execution,
                                              and innovation with purpose, the
                                              results are extraordinary. Looking
                                              ahead, our priorities remain
                                              grounded in our strategic intent:
                                              <br />
                                              <br />
                                              Let us carry this conviction into
                                              Q4—with courage to lead, speed to
                                              act, and pride in the impact we
                                              create.
                                              <br />
                                              <br />
                                              Thank you for being the force
                                              behind this journey. Together, we
                                              are not just building a company—we
                                              are building a legacy.
                                              <br />
                                              <br />
                                              With gratitude and determination,
                                              <br />
                                              <br />
                                              <strong>Sushil Gujrathi</strong>
                                              <br />
                                              <strong>
                                                Co-Founder and CEO
                                              </strong>
                                              <br />
                                              <strong>
                                                Comsense Technologies
                                              </strong>
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Our Latest Wins
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Wins a Strategic Deal
                                                  with a Top Aviation Company
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={AviationCompany}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We are proud to bag a deal with
                                                a top aviation company to help
                                                them accelerate their digital
                                                transformation journey. We will
                                                implement Salesforce Sales Cloud
                                                and Service Cloud, integrated
                                                with the brand’s source systems,
                                                to unify customer data,
                                                streamline sales processes, and
                                                enhance service efficiency. This
                                                transformation will enable
                                                improved sales visibility,
                                                faster response times, and
                                                seamless customer experiences,
                                                creating a stronger foundation
                                                for growth and loyalty.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  <strong>
                                                    Comsense is Excited to Be a
                                                    Part of the Digital
                                                    Transformation Journey of a
                                                    Leading Indian Water
                                                    Purifier Company
                                                  </strong>
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                IndianConsumerSolutionsCompany
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense will be aiding the
                                                transformation journey of a
                                                leading Indian Water Purifier
                                                company by unifying customer and
                                                asset data through Salesforce
                                                Clouds and Data Cloud. This will
                                                empower stakeholders with
                                                real-time Tableau dashboards
                                                thus enabling smarter, AI-driven
                                                decision-making. This
                                                transformation will eliminate
                                                silos, improve lead conversion,
                                                accelerate SLA adherence, and
                                                drive personalized engagement at
                                                scale thereby creating a single
                                                source of truth for customers,
                                                agents, and business teams
                                                alike.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  We Are Thrilled to Collaborate
                                                  with a Leading Real Estate
                                                  Company to Implement
                                                  Salesforce Data Cloud
                                                </strong>
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={RealEstateCompany2}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                As a part of this deal, we will
                                                enable advanced lead scoring and
                                                lead closure prediction models,
                                                empowering sales teams with
                                                actionable insights to
                                                accelerate conversion and
                                                maximize ROI.
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Awarded an Opportunity to
                                                  Expand Data Science LoB with a
                                                  Reputed Real Estate Company
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={RealEstateCompany}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We are expanding our Data
                                                Science line of business with a
                                                prominent real estate brand. As
                                                a part of the deal, we will
                                                deploy dedicated resources to
                                                strengthen the client’s
                                                analytics capabilities, enabling
                                                smarter predictions, sharper
                                                decision-making, and measurable
                                                business growth.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  Comsense Wins a MarTech
                                                  Transformation Deal with a
                                                  Market Leader in Adhesives
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={MarTechTransformationDeal}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We are extremely delighted with
                                                this win. As a part of this
                                                deal, we will implement
                                                Salesforce Data Cloud, Marketing
                                                Cloud, Datorama, and Adobe
                                                Target to help the brand unify
                                                customer data, activate
                                                hyper-personalized campaigns,
                                                and deliver real-time marketing
                                                intelligence. This
                                                transformation will bridge data
                                                and action—boosting engagement
                                                across channels, strengthening
                                                ROI visibility, and ensuring
                                                every customer journey is
                                                powered by insights and
                                                precision.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "red",
                                                  lineHeight: "28px",
                                                  textAlign: "center",
                                                }}
                                              >
                                                <strong>
                                                  A Win to Deliver AI-Driven
                                                  Innovation for a Prominent
                                                  Golf Brand
                                                </strong>
                                                <br />
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={GolfBrand}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Comsense is charting a new
                                                course with a leading golf brand
                                                to deliver AI-driven innovation.
                                                We will implement an AI Copilot
                                                solution, designed to optimize
                                                operations, assist
                                                decision-making, and enhance
                                                customer engagement across
                                                channels. At Comsense, we remain
                                                committed to turning AI into
                                                real-world business advantage.
                                              </p>
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width={375}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “Risk taking is the
                                                        cornerstone of empires.”{" "}
                                                      </i>
                                                      <br />
                                                      <br />
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Estee Lauder,
                                                        </span>{" "}
                                                        Businesswoman and
                                                        co-founder of Estee
                                                        Lauder
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              width={25}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                              align="left"
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-full"
                                              width={100}
                                              border={0}
                                              align="right"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuoteOne}
                                                      alt="img"
                                                      width={100}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      editable=""
                                                      label="image"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*  */}

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Comsense in Action
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Comsense at GEC Dubai 2025: Driving
                                            AI Collaboration and Growth
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={DubaiEvent}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We had the privilege of
                                                connecting with delegates,
                                                speakers, and industry leaders
                                                while showcasing{" "}
                                                <strong>
                                                  Comsense’s AI-ready solutions
                                                </strong>{" "}
                                                at our booth. The event served
                                                as an exceptional platform to
                                                exchange ideas, gain insights,
                                                and share experiences with some
                                                of the brightest minds across
                                                industries. GEC Dubai 2025 is a
                                                strategic initiative designed to
                                                bring together influential
                                                entrepreneurs, policymakers,
                                                thought leaders, and innovators
                                                under one roof to foster
                                                meaningful collaborations,
                                                explore cross-border
                                                opportunities, and drive
                                                sustainable economic growth. We
                                                are also proud to announce that
                                                during the event, Comsense
                                                signed an MoU with{" "}
                                                <strong>
                                                  Sanbook Quality Consultancy
                                                </strong>{" "}
                                                to train and empower{" "}
                                                <strong>
                                                  1,000 professionals on AI
                                                  across industries
                                                </strong>
                                                , marking a significant step in
                                                preparing the workforce for the
                                                future.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Retail in Motion: Driving Customer
                                            Engagement with Data <br />
                                            and AI
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={RetailInMotion}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Our Co-founder, Biju Nambiar,
                                              recently spoke at ‘Retail in
                                              Motion: Industry Leaders’
                                              Dialogue’, discussing how Data &
                                              AI are transforming customer
                                              engagement in retail and consumer
                                              goods. The session brought
                                              together industry leaders to
                                              discuss strategies, real-world use
                                              cases, and the creation of
                                              connected, intelligent ecosystems
                                              that foster growth and trust. Biju
                                              emphasized the role of{" "}
                                              <strong>
                                                AI-driven personalization,
                                                predictive analytics, and
                                                unified data platforms
                                              </strong>{" "}
                                              in delivering seamless and
                                              impactful customer experiences.
                                              Comsense continues to champion
                                              innovation, helping businesses
                                              turn data and AI into actionable
                                              insights.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={35} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Powering Personalized Retail with
                                            Salesforce
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={
                                                PoweringPersonalizedRetailWithSalesforce
                                              }
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              At a recent retail industry event,
                                              our client, who specializes in
                                              diamond and platinum jewelry,
                                              recently went live with Salesforce
                                              as their key platform. Comsense is
                                              currently driving the project
                                              forward, achieving the set
                                              objectives by unifying customer
                                              data into a{" "}
                                              <strong>
                                                single source of truth
                                              </strong>
                                              , enabling personalized, seamless
                                              shopping experiences. Our team is
                                              also building{" "}
                                              <strong>
                                                management-level dashboards
                                              </strong>{" "}
                                              to provide actionable insights,
                                              empowering the leaders to make
                                              faster, smarter decisions while
                                              enabling sales and service teams
                                              to deliver exceptional in-store
                                              experiences.
                                              <br />
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="25"></td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Case Study
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Check Out Our Latest Case Study
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                width: "100%",
                                                border:
                                                  "2px solid rgb(210, 210, 210)",
                                              }}
                                              src={caseStudy}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/*     <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>

              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* <layout label="1/1 content">
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tbody>
    <tr>
      <td align=center>
        <table align=center border=0 cellpadding=0 cellspacing=0>
          <tbody>
            <tr>
              <td width=600 align=center>
                <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
                  <tbody>
                    <tr>
                      <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                        <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                          <tbody>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center width=580
                                style="font-family:Century gothic,arial,sans-serif;font-size:24px;color:#4a4a4a;font-weight:100;line-height:30px">
                                <singleline label=title>Case Studies </singleline>
                              </td>
                            </tr>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td align=center>
                                <table width=40 bgcolor=#FF0000 style=border-radius:10px border=0 cellpadding=0
                                  cellspacing=0>
                                  <tbody>
                                    <tr>
                                      <td height=5 style=line-height:0;font-size:0px>&nbsp;</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <br>
                            <tr>
                              <td height=20></td>
                            </tr>
                            <tr>
                              <td width=580 align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:18px;color:red;line-height:28px;font-weight:700;text-align:center">
                                Comsense Quarterly Awards
                              </td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td width=580 align=center style=line-height:0>
                                <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                                  src=images/awards.png alt=img width=100% height=auto>
                              </td>
                            </tr>
                            <tr>
                              <td height=10></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Since we were unable to organize our Quarterly Award
                                  Ceremony in our previous quarter, we made it up by awarding people from two
                                  previous quarters together.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Rookie (Rising Star) Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Comsense is always proud of its young and fresh team
                                  members who excel very early in their careers. This time our Rising star awards
                                  were given to <strong>Abhishek Sontakke, Sneha Kshirsagar, and Girish
                                    Sahare</strong> for their excellent performances in such early days of their
                                  span at Comsense.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Star Performer Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content>Our best performers of the last two quarters were
                                  <strong>Anant Kadam, Shubham Chordia, and Soumy Dubey.</strong> They have gone
                                  beyond their roles to ensure Comsense’s success and thus rightly deserve the
                                  award. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Ace Contributors:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Rakhi Ankar</strong> was awarded the Ace
                                  Contributor award for being excellent in all roles and responsibilities given to
                                  her.<br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td align=left
                                style="font-family:Open sans,arial,sans-serif;font-size:16px;color:red;line-height:28px;font-weight:700;text-align:left">
                                Innovation Award:
                              </td>
                            </tr>
                            <tr>
                              <td align=center
                                style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                                <multiline label=content><strong>Suvaknata Rawat</strong> was awarded the
                                  innovation award for showcasing an excellent innovative approach towards problem
                                  solving and solutioning. <br></multiline>
                              </td>
                            </tr>
                            <tr>
                              <td height=15></td>
                            </tr>
                            <tr>
                              <td height=25></td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
    </layout> */}
          <layout label="1/1 content">
            {/* <table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table align=center border=0 cellpadding=0 cellspacing=0>
        <tr>
          <td width=600 align=center>
            <table class=table-full width=100% align=center border=0 cellpadding=0 cellspacing=0>
              <tr>
                <td bgcolor=#FFFFFF align=center style=text-align:center;vertical-align:top;font-size:0>
                  <table align=center width=90% border=0 cellspacing=0 cellpadding=0>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td width=580 align=center style=line-height:0>
                        <img style=display:block;line-height:0;font-size:0px;border:0;width:100%
                          src=images/five-years.png alt=img width=100% height=auto>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline label=content>
                          We were thrilled to honor Vishnu Kamath and Neerajkumar Gogavale with the Long Service
                          Award as they both completed 5 years with Comsense. We are thankful for their faith and
                          belief in the spirit of Comsense and wish them a long, fruitful journey ahead with us!
                          <br><br>
                        </multiline>
                      </td>
                    </tr>
                    <tr>
                      <td height=25></td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table> */}
          </layout>
          <table
            className="full"
            align="center"
            bgcolor="#333742"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td bgcolor="#FFFFFF" align="center">
                          <table
                            className="table-inner"
                            width={550}
                            border={0}
                            align="center"
                            cellPadding={0}
                            cellSpacing={0}
                          >
                            <tbody>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 24,
                                    color: "#4a4a4a",
                                    fontWeight: 100,
                                    lineHeight: "30px",
                                  }}
                                >
                                  <singleline label="title">
                                    The Technology Lens
                                  </singleline>
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    width={40}
                                    bgcolor="#FF0000"
                                    style={{ borderRadius: 10 }}
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          height={5}
                                          style={{ lineHeight: 0, fontSize: 0 }}
                                        >
                                          &nbsp;
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td
                                  width={580}
                                  align="center"
                                  style={{
                                    fontFamily: "Open sans,arial,sans-serif",
                                    fontSize: 18,
                                    color: "red",
                                    lineHeight: "28px",
                                    fontWeight: 700,
                                    textAlign: "center",
                                  }}
                                >
                                  AI in Project Management: Giving Clients a
                                  Strategic Edge
                                </td>
                              </tr>
                              <tr>
                                <td height={25} />
                              </tr>
                              <tr>
                                <td>
                                  <table
                                    width={150}
                                    className="table-full"
                                    border={0}
                                    align="left"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{ lineHeight: 0 }}
                                        >
                                          <img
                                            src={abhishek}
                                            width={150}
                                            alt="icon"
                                            style={{
                                              display: "block",
                                              lineHeight: 0,
                                              fontSize: 0,
                                              border: "5px solid #eaecf0",
                                            }}
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                  <table
                                    width={25}
                                    align="left"
                                    border={0}
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={15} />
                                      </tr>
                                    </tbody>
                                  </table>
                                  {/*[if (gte mso 9)|(IE)]>
                      </td>
                      <td>
                        <![endif]*/}
                                  <table
                                    className="table-full"
                                    width={375}
                                    border={0}
                                    align="right"
                                    cellPadding={0}
                                    cellSpacing={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td height={200} />
                                      </tr>
                                      <tr>
                                        <td
                                          align="center"
                                          style={{
                                            border: "0 solid #fff",
                                            borderRadius: 4,
                                          }}
                                        >
                                          <table
                                            width="90%"
                                            border={0}
                                            align="left"
                                            cellPadding={0}
                                            cellSpacing={0}
                                          >
                                            <tbody>
                                              <tr>
                                                <td
                                                  valign="bottom"
                                                  style={{
                                                    fontFamily:
                                                      "Century gothic,arial,sans-serif",
                                                    fontSize: 24,
                                                    color: "#4a4a4a",
                                                    fontWeight: 100,
                                                    lineHeight: "30px",
                                                    textAlign: "left",
                                                  }}
                                                >
                                                  <p
                                                    style={{
                                                      color: "#000",
                                                      fontFamily:
                                                        "Century Gothic",
                                                      fontSize: 14,
                                                      fontStyle: "normal",
                                                      fontWeight: 400,
                                                      lineHeight: "normal",
                                                      marginBottom: 0,
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        color: "#000",
                                                        fontFamily:
                                                          "Century Gothic",
                                                        fontSize: 14,
                                                        fontStyle: "normal",
                                                        fontWeight: 700,
                                                        lineHeight: "normal",
                                                      }}
                                                    >
                                                      - By Abhishek Deshpande,
                                                      Project Manager{" "}
                                                    </span>
                                                  </p>
                                                </td>
                                              </tr>
                                              <tr>
                                                <td height={10} />
                                              </tr>
                                            </tbody>
                                          </table>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td height={10} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
          {/* Tech Trends */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "24px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              For decades, project management
                                              has been about balancing scope,
                                              cost, and timelines. It is a
                                              delicate act guided largely by
                                              human experience and intuition.
                                              But in today’s environment of
                                              compressed delivery cycles, rising
                                              complexity, and constant
                                              disruption, traditional methods
                                              are no longer enough. Artificial
                                              Intelligence (AI) is redefining
                                              project management; not as a
                                              back-office efficiency tool, but
                                              as a strategic enabler for
                                              organizations seeking a decisive
                                              competitive edge.
                                              <br />
                                              <br />
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                At <strong>Comsense</strong>, we
                                                are leading this shift by
                                                embedding AI into every layer of
                                                project delivery. Unlike generic
                                                tools that focus only on
                                                automation, our approach is
                                                about{" "}
                                                <strong>
                                                  using AI as a strategic
                                                  partner
                                                </strong>
                                                —bringing foresight, precision,
                                                and agility to client
                                                engagements. Over the next few
                                                quarters, this is one of our
                                                sharpest focus areas, with
                                                practical implementations
                                                already underway.
                                                <br />
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                One of the most powerful
                                                applications is{" "}
                                                <strong>
                                                  predictive analytics
                                                </strong>
                                                . By mining historical project
                                                data, AI can forecast risks,
                                                budget deviations, or potential
                                                bottlenecks long before they
                                                surface. For example, global
                                                consulting firms now use
                                                AI-driven models to predict
                                                whether multi-million-dollar ERP
                                                rollouts are likely to miss
                                                deadlines by analyzing patterns
                                                across hundreds of similar
                                                programs. At Comsense, we bring
                                                this predictive capability to
                                                our clients, helping them{" "}
                                                <strong>
                                                  course-correct proactively
                                                  rather than firefight
                                                  reactively
                                                </strong>
                                                .
                                              </p>
                                              {/* <br> */}
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Equally transformative is{" "}
                                                <strong>
                                                  AI-powered automation
                                                </strong>
                                                . Repetitive tasks like status
                                                updates, schedule adjustments,
                                                progress reporting, are now
                                                streamlined, allowing project
                                                managers to focus on
                                                higher-value work such as
                                                stakeholder alignment,
                                                innovation, and strategic
                                                decision-making. More advanced
                                                platforms go a step further,
                                                recommending{" "}
                                                <strong>
                                                  optimal team allocations
                                                </strong>{" "}
                                                based on skills, availability,
                                                and historical performance,
                                                ensuring projects remain on
                                                track without overburdening
                                                teams.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                Emerging technologies are also
                                                giving rise to{" "}
                                                <strong>
                                                  intelligent project assistants
                                                </strong>{" "}
                                                like real-time collaborators
                                                that surface insights, highlight
                                                risks, and even suggest
                                                next-best actions. Imagine a
                                                project manager being alerted
                                                that a critical dependency is at
                                                risk two weeks before it
                                                cascades into a delay—AI makes
                                                this foresight operationally
                                                possible.
                                              </p>
                                              <p
                                                style={{
                                                  fontFamily:
                                                    "Open sans,arial,sans-serif",
                                                  fontSize: 14,
                                                  color: "#9b9b9b",
                                                  lineHeight: "24px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                At Comsense, our mission goes
                                                beyond improving project
                                                efficiency. By integrating AI
                                                into the project lifecycle, we
                                                enable clients to{" "}
                                                <strong>
                                                  turn data into strategy -
                                                </strong>
                                                delivering with speed,
                                                precision, and adaptability. In
                                                a landscape where execution
                                                excellence often defines market
                                                leadership, we are committed to
                                                giving our clients the edge they
                                                need to stay ahead.
                                              </p>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* <layout label=quote>
<table class=full bgcolor=#333742 align=center width=100% border=0 cellspacing=0 cellpadding=0>
  <tr>
    <td align=center>
      <table class=table-full width=600 style=max-width:600px border=0 align=center cellpadding=0 cellspacing=0>
        <tr>
          <td bgcolor=#FFFFFF align=center>
            <table class=table-inner width=550 style=max-width:550px border=0 align=center cellpadding=0
              cellspacing=0>
              <tr>
                <td height=25></td>
              </tr>
              <tr>
                <td style="border:2px solid #d2d2d2" align=center>
                  <table class=table-inner width=500 border=0 align=center cellpadding=0 cellspacing=0>
                    <tr>
                      <td height=20></td>
                    </tr>
                    <tr>
                      <td align=center>
                        <table class=table-full width=375 border=0 align=left cellpadding=0 cellspacing=0>
                          <tr>
                            <td
                              style="font-family:Open sans,arial,sans-serif;font-size:16px;color:#9b9b9b;line-height:28px;font-weight:600">
                              <multiline label=quote><i>“Winning as a team is better than anything else. It’s
                                  great to share success”</i>
                                <br>
                                <span
                                  style="color:#9b9b9b;font-family:Century Gothic;font-size:14px;font-style:normal;font-weight:700;line-height:normal">
                                  <span
                                    style="color:#000;font-family:Century Gothic;font-size:14px;font-style:normal;font-weight:700;line-height:normal">-
                                    Jim Harbaugh, </span> American Football Coach</span>
                              </multiline>
                            </td>
                          </tr>
                        </table>
                        <table width=25 border=0 cellpadding=0 cellspacing=0 align=left>
                          <tr>
                            <td height=10></td>
                          </tr>
                        </table>
                        <table class=table-full width=100 border=0 align=right cellpadding=0 cellspacing=0>
                          <tr>
                            <td align=center style=line-height:0>
                              <img src=images/Jim-Harbaugh.jpg alt=img width=100
                                style=display:block;line-height:0;font-size:0px;border:0 editable label=image>
                            </td>
                          </tr>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height=20></td>
                    </tr>
                  </table>
                </td>
              </tr>
              <tr>
                <td height=25></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </td>
  </tr>
</table>
    </layout> */}
          {/* Business Quote 2 */}
          <layout label="quote">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      className="table-full"
                      width={600}
                      style={{ maxWidth: 600 }}
                      border={0}
                      align="center"
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td bgcolor="#FFFFFF" align="center">
                            <table
                              className="table-inner"
                              width={550}
                              style={{ maxWidth: 550 }}
                              border={0}
                              align="center"
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td height={20} />
                                </tr>
                                <tr>
                                  <td
                                    style={{ border: "2px solid #d2d2d2" }}
                                    align="center"
                                  >
                                    <table
                                      className="table-inner"
                                      width={500}
                                      border={0}
                                      align="center"
                                      cellPadding={0}
                                      cellSpacing={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-full"
                                              width={375}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    style={{
                                                      fontFamily:
                                                        "Open sans,arial,sans-serif",
                                                      fontSize: 16,
                                                      color: "#9b9b9b",
                                                      lineHeight: "28px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    <multiline label="quote">
                                                      <i>
                                                        “If you start thinking
                                                        that only your biggest
                                                        and shiniest moments
                                                        count, you’re setting
                                                        yourself up to feel like
                                                        a failure most of the
                                                        time.”{" "}
                                                      </i>
                                                      <br />
                                                      <span
                                                        style={{
                                                          color: "#9b9b9b",
                                                          fontFamily:
                                                            "Century Gothic",
                                                          fontSize: 14,
                                                          fontStyle: "normal",
                                                          fontWeight: 700,
                                                          lineHeight: "normal",
                                                        }}
                                                      >
                                                        <span
                                                          style={{
                                                            color: "#000",
                                                            fontFamily:
                                                              "Century Gothic",
                                                            fontSize: 14,
                                                            fontStyle: "normal",
                                                            fontWeight: 700,
                                                            lineHeight:
                                                              "normal",
                                                          }}
                                                        >
                                                          - Chris Hadfield,
                                                        </span>{" "}
                                                        Former Canadian Space
                                                        Agency Astronaut
                                                      </span>
                                                    </multiline>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              width={25}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                              align="left"
                                            >
                                              <tbody>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-full"
                                              width={100}
                                              border={0}
                                              align="right"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    align="center"
                                                    style={{ lineHeight: 0 }}
                                                  >
                                                    <img
                                                      src={BusinessQuote2}
                                                      alt="img"
                                                      width={100}
                                                      style={{
                                                        display: "block",
                                                        lineHeight: 0,
                                                        fontSize: 0,
                                                        border: 0,
                                                      }}
                                                      editable=""
                                                      label="image"
                                                    />
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                                <tr>
                                  <td height={25} />
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Client Testimonials */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Client Testimonial
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                              border:
                                                "2px solid rgb(210, 210, 210)",
                                              padding: "20px",
                                            }}
                                          >
                                            <multiline label="content">
                                              <p
                                                style={{
                                                  fontFamily: "Open Sans",
                                                  fontSize: "14px",
                                                  color: "#9b9b9b",
                                                  lineHeight: "28px",
                                                  textAlign: "justify",
                                                }}
                                              >
                                                We truly appreciate the
                                                exceptional performance of the
                                                Comsense team, from strategizing
                                                the campaign to flawless
                                                execution. Their efforts helped
                                                us recover lost customers and
                                                drive significant additional
                                                revenue. We are excited to
                                                continue scaling more
                                                initiatives together.
                                              </p>
                                              <strong>
                                                <i>
                                                  - CRM Manager of a leading
                                                  global organization in the
                                                  automotive sector{" "}
                                                </i>
                                              </strong>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          {/* <td align=center
                        style="font-family:Open sans,arial,sans-serif;font-size:14px;color:#9b9b9b;line-height:28px;text-align:justify">
                        <multiline lable=content>
                          <strong>Umang and Team, Congratulations on a successful project handover!!</strong>
                          <p>Shout out to the Data Cloud implementation team especially! , @Vishnu Kamath
                            @Ranjith Rajmohan @Shubham Bhosekar and @Niharika Vashishtha - great work overall
                            taking this to closure, I know this was not easy to begin with.. we faced several
                            blockers right from discovery. I appreciate the team's perseverance throughout several
                            rounds of corrections & re-work. The team has run 10+ unification rules and validated
                            cases by region and by category (B2B and Individual owners). @Vishnu Kamath, @Ranjith
                            Rajmohan -
                            Your experience with Python and data helped here to expedite the transformation and
                            cleanup logic
                            for large data sets run analysis for the spread, and point out the gaps.</p>
                          <strong><i>- Anusha Vrushabendraswamy | Lead Technical Architect, Strategic Accounts
                              Excellence | Salesforce</i></strong>
                        </multiline>
                      </td> */}
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Events & Celebrations */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Life at Comsense
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>

                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            10 Year Celebration – A Weekend of
                                            Tales & Laughter
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={annualPicnic}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              In August, the Comsense team
                                              celebrated 10 years of building,
                                              growing, and solving challenges
                                              together during our annual picnic
                                              at Karjat. The weekend was full of
                                              laughter, team bonding, and
                                              reflection. From sharing stories
                                              of our early days to creating new
                                              memories, every team member
                                              relived the nostalgia and filled
                                              their hearts with renewed love for
                                              the organization. The celebration
                                              was made extra special by
                                              announcing the Leadership Awards
                                              that recognized outstanding
                                              contributions, specially of Vishnu
                                              Kamath & Omkar Dhapte,
                                              highlighting the grit and passion
                                              that drive Comsense forward.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Celebrating Success in Style
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={Celebration}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              In line with our core belief in
                                              celebrating every big and small
                                              event, we recently celebrated the
                                              success of one of our major
                                              projects. The celebration was done
                                              with our incredible team, and the
                                              milestone was marked with a
                                              cake-cutting ceremony, recognizing
                                              the dedication and collaboration
                                              that made it possible. This
                                              achievement reflects the team’s
                                              ability to overcome challenges and
                                              deliver excellence. It was a
                                              moment of pride, joy, and
                                              gratitude shared by all.
                                              Congratulations to the entire team
                                              for turning vision into reality!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 18,
                                              color: "red",
                                              lineHeight: "28px",
                                              fontWeight: 700,
                                              textAlign: "center",
                                            }}
                                          >
                                            Navratri Celebration
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={NavaratriCelebration}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              This Navratri, our workplace was
                                              filled with festive cheer as the
                                              team came together to mark the
                                              occasion with enthusiasm and joy.
                                              The celebrations featured
                                              traditional attire, music, and
                                              spirited garba and dandiya
                                              performances that brought vibrancy
                                              to the office. More than just a
                                              cultural event, it was a moment of
                                              connection—strengthening bonds
                                              among colleagues and reflecting
                                              the values of unity and positivity
                                              that define our work culture.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Awards @Comsense
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height="30"></td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "250px",
                                              }}
                                              src={award}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <strong>
                                                Quarterly Awards: Celebrating
                                                Excellence
                                              </strong>
                                              <br />
                                              At Comsense, we believe that
                                              recognizing and rewarding hard
                                              work is just as important as
                                              achieving results. Our people are
                                              the driving force behind every
                                              success, and we deeply value the
                                              extra effort they put in to go
                                              beyond expectations.
                                              <br />
                                              <br />
                                              While we could not conduct
                                              official award ceremonies in the
                                              first two quarters, we were
                                              delighted to take the special
                                              occasion of our 10th anniversary
                                              to honor and celebrate this year’s
                                              winners.
                                              <br />
                                              <br />
                                              The winners of the Quarterly
                                              Awards (Q1) were:
                                              <br />• Rookie: Revati Vidhale{" "}
                                              <br />• Star Performer: Vijay
                                              Pujari
                                              <br /> • Ace Contributor: Khushi
                                              Songirkar <br />• Team Player:
                                              Srushti Labade, Ritu Shah <br />•
                                              Customer Delight: Rutuja Rajput{" "}
                                              <br />• Innovation: Swadhin
                                              Nagulpelli
                                              <br />
                                              <br />
                                              The winers of the Quarterly Awards
                                              (Q2) were:
                                              <br />
                                              • Rookie: Pranav Konde
                                              <br />• Star Performer: Wasim
                                              Miya, Shreyash Pole
                                              <br />• Ace Contributor: Payal
                                              Maisheri, Suraj Mudliar
                                              <br />• Team Player: Akshay
                                              Waghmare, Dipali More, Amit
                                              Mandhare
                                              <br />• Customer Delight: Pankaj
                                              Patil, Rutika Bhikule
                                              <br />
                                              <br />
                                              Special Admin Awards were won by
                                              Sheetal Rao, Sumedh Pawaskar, and
                                              Sumedh Natekar.
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>

          {/* Associate Speak */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Voices of Comsense
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={10} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td height={25} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                            }}
                                                          >
                                                            <img
                                                              src={rishabh}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              instrumental in
                                                              shaping my
                                                              professional
                                                              journey — offering
                                                              continuous
                                                              learning,
                                                              meaningful
                                                              opportunities, and
                                                              the trust to
                                                              contribute to key
                                                              initiatives. Over
                                                              time, I’ve not
                                                              only developed new
                                                              skills but also
                                                              gained the
                                                              confidence to take
                                                              ownership and make
                                                              an impact. The
                                                              leadership
                                                              deserves special
                                                              mention for their
                                                              clarity of vision
                                                              and ability to
                                                              empower people at
                                                              every level.
                                                              Looking back, it’s
                                                              been a deeply
                                                              enriching
                                                              experience, and
                                                              I’m proud to be
                                                              part of an
                                                              organization that
                                                              values both people
                                                              and progress.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Rishabh
                                                                  Manchanda,
                                                                </strong>{" "}
                                                                Sr. Martech
                                                                Associate
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                                <tr>
                                                  <td height={10} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner desktop-view"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              a great place for
                                                              me to kickstart my
                                                              career. The
                                                              learning curve has
                                                              been steep, but
                                                              incredibly
                                                              rewarding. I’ve
                                                              grown so much,
                                                              both
                                                              professionally and
                                                              personally. What I
                                                              love most is how
                                                              innovation is
                                                              always at the core
                                                              of what we do,
                                                              which keeps the
                                                              work exciting and
                                                              future-focused.
                                                              The culture here
                                                              is engaging and
                                                              collaborative, and
                                                              every
                                                              milestone—big or
                                                              small—is
                                                              celebrated. That
                                                              recognition not
                                                              only builds a
                                                              sense of
                                                              accomplishment but
                                                              also motivates me
                                                              to push further
                                                              and aim higher.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Juhi Shah
                                                                </strong>
                                                                , Trainee
                                                                software
                                                                engineer{" "}
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={30} />
                                                        </tr>
                                                        <tr>
                                                          <td height={5} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              src={JuhiShah}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>
                                            <table
                                              className="table-inner mobile-responsive"
                                              style={{
                                                width: "100%!important",
                                                maxWidth: "100%!important",
                                              }}
                                              width={550}
                                              align="center"
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <table
                                                      className="table-full"
                                                      width={150}
                                                      align="left"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight: 28,
                                                            }}
                                                          >
                                                            <img
                                                              // src={rohit}
                                                              src={JuhiShah}
                                                              alt="img"
                                                              width={150}
                                                              style={{
                                                                display:
                                                                  "block",
                                                                lineHeight: 0,
                                                                fontSize: 0,
                                                                border: 0,
                                                                margin:
                                                                  "0 auto",
                                                              }}
                                                              editable=""
                                                              label="image"
                                                            />
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    {/*[if (gte mso 9)|(IE)]>

                                </td>

                                <td>

                                  <![endif]*/}
                                                    <table
                                                      width={25}
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                      align="left"
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={15} />
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                    <table
                                                      className="table-full"
                                                      width={370}
                                                      align="right"
                                                      border={0}
                                                      cellPadding={0}
                                                      cellSpacing={0}
                                                    >
                                                      <tbody>
                                                        <tr>
                                                          <td height={10} />
                                                        </tr>
                                                        <tr>
                                                          <td
                                                            align="center"
                                                            style={{
                                                              fontFamily:
                                                                "Open sans,arial,sans-serif",
                                                              fontSize: 14,
                                                              color: "#9b9b9b",
                                                              lineHeight:
                                                                "28px",
                                                              textAlign:
                                                                "justify",
                                                            }}
                                                          >
                                                            <multiline label="content">
                                                              <span
                                                                style={{
                                                                  color:
                                                                    "#9b9b9b",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                  fontSize: 60,
                                                                  fontStyle:
                                                                    "normal",
                                                                  fontWeight: 400,
                                                                  lineHeight:
                                                                    "22px",
                                                                  letterSpacing:
                                                                    "-1.2px",
                                                                }}
                                                              >
                                                                “
                                                              </span>
                                                              Comsense has been
                                                              a great place for
                                                              me to kickstart my
                                                              career. The
                                                              learning curve has
                                                              been steep, but
                                                              incredibly
                                                              rewarding. I’ve
                                                              grown so much,
                                                              both
                                                              professionally and
                                                              personally. What I
                                                              love most is how
                                                              innovation is
                                                              always at the core
                                                              of what we do,
                                                              which keeps the
                                                              work exciting and
                                                              future-focused.
                                                              The culture here
                                                              is engaging and
                                                              collaborative, and
                                                              every
                                                              milestone—big or
                                                              small—is
                                                              celebrated. That
                                                              recognition not
                                                              only builds a
                                                              sense of
                                                              accomplishment but
                                                              also motivates me
                                                              to push further
                                                              and aim higher.
                                                              <br />
                                                              <p
                                                                style={{
                                                                  fontSize:
                                                                    "14px",
                                                                  color:
                                                                    "#9b9b9b",
                                                                  lineHeight:
                                                                    "28px",
                                                                  textAlign:
                                                                    "justify",
                                                                  fontFamily:
                                                                    "Open Sans",
                                                                }}
                                                              >
                                                                <strong>
                                                                  - Juhi Shah
                                                                </strong>
                                                                , Trainee
                                                                software
                                                                engineer{" "}
                                                              </p>
                                                            </multiline>
                                                          </td>
                                                        </tr>
                                                      </tbody>
                                                    </table>
                                                  </td>
                                                </tr>
                                                <tr>
                                                  <td height={25} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              className="table-inner"
                                              width={500}
                                              border={0}
                                              align="left"
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td align="center"></td>
                                                </tr>
                                                <tr>
                                                  <td height={20} />
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Welcome Aboard */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              Welcome Aboard
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              Nothing excites us more than
                                              seeing our team grow with every
                                              passing quarter.
                                              <br />
                                              <br />
                                              We are delighted to welcome Rupesh
                                              Kulkarni, a seasoned delivery
                                              leader with over 15 years of
                                              experience driving large-scale
                                              digital transformation across
                                              industries including telecom,
                                              banking, oil & gas, retail,
                                              MarTech, and EdTech. With
                                              expertise spanning CRM, TIBCO,
                                              IoT, web, mobile, and data
                                              platforms, he has successfully led
                                              global teams and complex
                                              portfolios. Rupesh brings deep
                                              expertise in agile delivery,
                                              stakeholder engagement, and risk
                                              management, and is passionate
                                              about leveraging innovation to
                                              deliver scalable, customer-focused
                                              solutions that create meaningful
                                              impact.
                                              <br />
                                              <br />
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "250px",
                                                maxWidth: "100%",
                                                margin: "0 auto",
                                              }}
                                              src={rupesh}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td
                                            valign="bottom"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <p
                                              style={{
                                                color: "#000",
                                                fontFamily: "Century Gothic",
                                                fontSize: 14,
                                                fontStyle: "normal",
                                                fontWeight: 400,
                                                lineHeight: "normal",
                                                marginBottom: 0,
                                                textAlign: "center",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  color: "#000",
                                                  fontFamily: "Century Gothic",
                                                  fontSize: 14,
                                                  fontStyle: "normal",
                                                  fontWeight: 700,
                                                  lineHeight: "normal",
                                                }}
                                              >
                                                Rupesh Kulkarni
                                                <br /> Vice President, Delivery{" "}
                                              </span>
                                            </p>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br />A warm welcome to
                                              all—wishing you a fulfilling and
                                              successful journey with Team
                                              Comsense!
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={joinees}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          {/* Spiritual Corner */}
          <layout label="1/1 content">
            <table
              className="full"
              bgcolor="#333742"
              align="center"
              width="100%"
              border={0}
              cellSpacing={0}
              cellPadding={0}
            >
              <tbody>
                <tr>
                  <td align="center">
                    <table
                      align="center"
                      border={0}
                      cellPadding={0}
                      cellSpacing={0}
                    >
                      <tbody>
                        <tr>
                          <td width={600} align="center">
                            <table
                              className="table-full"
                              width="100%"
                              align="center"
                              border={0}
                              cellPadding={0}
                              cellSpacing={0}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    bgcolor="#FFFFFF"
                                    align="center"
                                    style={{
                                      textAlign: "center",
                                      verticalAlign: "top",
                                      fontSize: 0,
                                    }}
                                  >
                                    <br />
                                    <table
                                      align="center"
                                      width="90%"
                                      border={0}
                                      cellSpacing={0}
                                      cellPadding={0}
                                    >
                                      <tbody>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Century gothic,arial,sans-serif",
                                              fontSize: 24,
                                              color: "#4a4a4a",
                                              fontWeight: 100,
                                              lineHeight: "30px",
                                            }}
                                          >
                                            <singleline label="title">
                                              {" "}
                                              Inner Focus{" "}
                                            </singleline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={20} />
                                        </tr>
                                        <tr>
                                          <td align="center">
                                            <table
                                              width={40}
                                              bgcolor="#FF0000"
                                              style={{ borderRadius: 10 }}
                                              border={0}
                                              cellPadding={0}
                                              cellSpacing={0}
                                            >
                                              <tbody>
                                                <tr>
                                                  <td
                                                    height={5}
                                                    style={{
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                    }}
                                                  >
                                                    &nbsp;
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={30} />
                                        </tr>
                                        <tr>
                                          <td
                                            width={580}
                                            align="center"
                                            style={{ lineHeight: 0 }}
                                          >
                                            <img
                                              style={{
                                                display: "block",
                                                lineHeight: 0,
                                                fontSize: 0,
                                                border: 0,
                                                width: "100%",
                                              }}
                                              src={daji}
                                              alt="img"
                                              width="100%"
                                              height="auto"
                                            />
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "justify",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br />
                                              Daaji’s message on the
                                              International Day of Peace 2025
                                              emphasizes that peace is our true
                                              nature, discovered through
                                              meditation, prayer, and mindful
                                              living. Inner peace radiates
                                              outward, uplifting families,
                                              communities, and the world.
                                              <br />
                                              <br />
                                              Applauding Heartfulness Canada’s
                                              21-day Peace Challenge, he reminds
                                              us that becoming a Peace
                                              Ambassador is a promise to listen,
                                              heal, unite, and let the heart be
                                              the force that unites humanity.
                                            </multiline>
                                          </td>
                                        </tr>

                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <multiline label="content">
                                              <br />
                                              <a
                                                href=" https://www.youtube.com/watch?v=8R7wtnVjlEI"
                                                target="_blank"
                                                style={{
                                                  color: "#9b9b9b",
                                                  fontFamily: "Open Sans",
                                                  fontSize: 14,
                                                  fontStyle: "normal",
                                                  fontWeight: 700,
                                                  lineHeight: "22px",
                                                  letterSpacing: "-.28px",
                                                  textDecorationLine:
                                                    "underline",
                                                  textAlign: "left !important",
                                                }}
                                              >
                                                Video:
                                                https://www.youtube.com/watch?v=8R7wtnVjlEI
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td
                                            align="center"
                                            style={{
                                              fontFamily:
                                                "Open sans,arial,sans-serif",
                                              fontSize: 14,
                                              color: "#9b9b9b",
                                              lineHeight: "28px",
                                              textAlign: "left",
                                            }}
                                          >
                                            <multiline label="content">
                                              <a
                                                href="https://heartfulness.org/in/"
                                                target="_blank"
                                                style={{
                                                  color: "#9b9b9b",
                                                  fontFamily: "Open Sans",
                                                  fontSize: 14,
                                                  fontStyle: "normal",
                                                  fontWeight: 700,
                                                  lineHeight: "22px",
                                                  letterSpacing: "-.28px",
                                                  textDecorationLine:
                                                    "underline",
                                                  textAlign: "left !important",
                                                }} rel="noreferrer"
                                              >
                                                More about Heartfulness:
                                                www.heartfulness.org
                                                <br />
                                                <br />
                                              </a>
                                            </multiline>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td height={25} />
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </layout>
          <table
            className="full"
            bgcolor="#333742"
            align="center"
            width="100%"
            border={0}
            cellSpacing={0}
            cellPadding={0}
          >
            <tbody>
              <tr>
                <td align="center">
                  <table
                    className="table-full"
                    width={600}
                    style={{ maxWidth: 600 }}
                    border={0}
                    align="center"
                    cellPadding={0}
                    cellSpacing={0}
                  >
                    <tbody>
                      <tr>
                        <td
                          align="center"
                          background={city}
                          bgcolor="#515663"
                          style={{
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        >
                          <table
                            align="center"
                            width="95%"
                            border={0}
                            cellSpacing={0}
                            cellPadding={0}
                          >
                            <tbody>
                              <tr>
                                <td height={20} />
                              </tr>
                              <tr>
                                <td
                                  align="center"
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 22,
                                    fontWeight: 600,
                                    lineHeight: "30px",
                                    color: "#fff",
                                    letterSpacing: 1,
                                  }}
                                >
                                  Thanks for reading.
                                  <br />
                                  <span
                                    style={{
                                      fontFamily:
                                        "Century gothic,arial,sans-serif",
                                      fontSize: 14,
                                      fontWeight: 400,
                                      color: "#fff",
                                      letterSpacing: 1,
                                    }}
                                  >
                                    Did someone share this with you?{" "}
                                    <a
                                      style={{ color: "#fff" }}
                                      href="https://www.comsenseconsulting.com/newsletter/subscribe.html"
                                      target="_blank" rel="noreferrer"
                                    >
                                      <u>Sign up</u>
                                    </a>{" "}
                                    here.
                                  </span>
                                </td>
                              </tr>
                              <tr>
                                <td height={15} />
                              </tr>
                              <tr>
                                <td align="center">
                                  <table
                                    align="center"
                                    border={0}
                                    cellSpacing={0}
                                    cellPadding={0}
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          bgcolor="#FF0000"
                                          height={40}
                                          style={{
                                            fontFamily:
                                              "Century Gothic,sans-serif",
                                            fontSize: 14,
                                            color: "#4a4a4a",
                                            fontWeight: 700,
                                            paddingLeft: 15,
                                            paddingRight: 16,
                                            letterSpacing: "1.5px",
                                          }}
                                        >
                                          <a
                                            href="https://www.comsensetechnologies.com/newsletter/subscribe.html"
                                            style={{
                                              textDecoration: "none",
                                              color: "#fff",
                                              borderRadius: 5,
                                            }}
                                            target="_blank" rel="noreferrer"
                                          >
                                            SUBSCRIBE
                                          </a>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                              <tr>
                                <td
                                  style={{
                                    fontFamily:
                                      "Century gothic,arial,sans-serif",
                                    fontSize: 11,
                                    fontWeight: 400,
                                    color: "#fff",
                                    letterSpacing: 1,
                                    textAlign: "center",
                                  }}
                                >
                                  <br />
                                  If you liked this Newsletter, please recommend
                                  it to someone you know.
                                  <br />
                                  Or why not even share it on Twitter or
                                  Linkedin? … enough right?
                                  <br />
                                  If you don’t want to receive future
                                  Newsletters, please click here to{" "}
                                  <a
                                    style={{ color: "#fff" }}
                                    href="https://www.comsensetechnologies.com/newsletter/unsubscribe.html"
                                    target="_blank" rel="noreferrer"
                                  >
                                    <u>unsubscribe</u>
                                  </a>
                                  .<br />
                                  We will miss you!
                                  <br />
                                  <br />
                                  {/* View April 2024 Newsletter Here <a style=color:#fff
                  href=https://comsensetechnologies.com/wp-content/newsletter/april-2024/
                  target=_blank><u>here</u></a>. */}
                                </td>
                              </tr>
                              <tr>
                                <td height={20} />
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </repeater>
        <table
          className="full"
          bgcolor="#333742"
          align="center"
          width="100%"
          border={0}
          cellSpacing={0}
          cellPadding={0}
        >
          <tbody>
            <tr>
              <td align="center">
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td bgcolor="#FFFFFF" align="center">
                        <table
                          className="table-inner"
                          width={550}
                          style={{ maxWidth: 550 }}
                          border={0}
                          align="center"
                          cellPadding={0}
                          cellSpacing={0}
                        >
                          <tbody>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td
                                align="center"
                                style={{
                                  fontFamily: '"Open sans",Arial,sans-serif',
                                  color: "#4a4a4a",
                                  fontSize: 16,
                                }}
                              >
                                FOLLOW US
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                            <tr>
                              <td>
                                <table
                                  className="table-full"
                                  border={0}
                                  align="center"
                                  cellPadding={0}
                                  cellSpacing={0}
                                >
                                  <tbody>
                                    <tr>
                                      <td>
                                        <table
                                          border={0}
                                          align="center"
                                          cellPadding={0}
                                          cellSpacing={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.facebook.com/Comsenseconsulting/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={fb1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-1"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                                target="_blank"
                                              >
                                                <a href="https://twitter.com/ComsenseTech">
                                                  <img
                                                    src={tw1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-2"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="http://linkedin.com/company/comsense-consulting"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ln1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-3"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.instagram.com/comsensemktg/"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={ig1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-4"
                                                  />
                                                </a>
                                              </td>
                                              <td width={20} />
                                              <td
                                                align="center"
                                                style={{ lineHeight: 0 }}
                                              >
                                                <a
                                                  href="https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g"
                                                  target="_blank" rel="noreferrer"
                                                >
                                                  <img
                                                    src={yt1}
                                                    alt="img"
                                                    width={20}
                                                    style={{
                                                      display: "block",
                                                      lineHeight: 0,
                                                      fontSize: 0,
                                                      border: 0,
                                                    }}
                                                    editable=""
                                                    label="social-5"
                                                  />
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td height={25} />
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height={5} bgcolor="#FF0000" />
                    </tr>
                  </tbody>
                </table>
                <table
                  className="table-full"
                  width={600}
                  style={{ maxWidth: 600 }}
                  border={0}
                  align="center"
                  cellPadding={0}
                  cellSpacing={0}
                >
                  <tbody>
                    <tr>
                      <td height={25} />
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </>
    </>
  );
};

export default September;
